import React, {MouseEvent, useEffect, useState} from "react";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserMenuModel } from "app/model/ua/user-menu";
import { setCurrentMenu } from "app/reducers/menuSlice";
import Account from "app/components/layout/comp/Account";
import MenuItem from "./comp/MenuItem";
import MegaMenu from "./MegaMenu";
import {clearUserInfo} from "app/reducers/userSlice";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import { UserInfoModel } from "app/model/ua/user-info";
import { logoutRedirect } from "app/config/oidc";

export default function Header() {
  const userInfo = useAppSelector(state => state.userInfo.userInfo);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const { menus, flatMenus, rootMenu }: any = useAppSelector(state => state.menus);
  const [activeMenu, setActiveMenu] = useState<UserMenuModel>();

  useEffect(() => {
    if (rootMenu) {
      setActiveMenu(rootMenu);
    } else {
      const currentMenu = flatMenus.find((menu: UserMenuModel) =>
        menu.menuUrlAddr && currentUrl.startsWith(menu.menuUrlAddr));
      if (currentMenu) {
        let tempArray: UserMenuModel[] = [];
        let currentMenuDepth = currentMenu.depth ?? 0;
        if (currentMenuDepth > 1) {
          tempArray.push(currentMenu);
          for (let i = 0; i < currentMenuDepth - 1; i++) {
            const upperMenuId = tempArray[0].uppoMenuId;
            if (upperMenuId) {
              const upperMenu = flatMenus.find((menu: UserMenuModel) => menu.menuId === upperMenuId);
              if (upperMenu) {
                tempArray.unshift(upperMenu);
              }
            }
          }
          dispatch(setCurrentMenu({currentMenu: currentMenu, rootMenu: tempArray[0]}));
          setActiveMenu(tempArray[0]);
        } else {
          dispatch(setCurrentMenu({currentMenu: currentMenu, rootMenu: currentMenu}));
          setActiveMenu(currentMenu);
        }
      }
    }
  }, [flatMenus, currentUrl, rootMenu]);

  function handleClickMenu(item: UserMenuModel, rootMenu: UserMenuModel) {
    setActiveMenu(item);
    if (item.subMenus && item.subMenus.length > 0) {
      dispatch(setCurrentMenu({ currentMenu: item.subMenus[0], rootMenu: rootMenu }));
    } else {
      dispatch(setCurrentMenu({ currentMenu: item, rootMenu: rootMenu }));
    }
    if (item.menuUrlAddr && item.menuUrlAddr !== "") {
      navigate(item.menuUrlAddr);
    }
  }

  async function handleClickLogout(e: MouseEvent) {
    e.preventDefault();
    dispatch(clearUserInfo());
    logoutRedirect();
  }

  const getUserRoleByUserInfo = (user: UserInfoModel) => {
    if (UserInfoUtil.hasRole(user, AuthConstant.ADMIN)) {
      return '관리자';
    } else if (UserInfoUtil.hasRole(user, AuthConstant.R001)) {
      return '산단기업';
    } else if (UserInfoUtil.hasRole(user, AuthConstant.R002)) {
      return '중개업자';
    } else {
      return '사용자';
    }
  };

  return (
    <>
      <header id="header">
        <div className="header-wrap">
          <div className="side-wrap">
            <Link to="/" title="홈 화면으로 이동">
              <h1 className="logo">
                <span className="hid">e.CLOUD</span>
              </h1>
            </Link>
            <div className="gnb-wrap">
              <div id="gnb">
                <div className="depth01">
                  <ul>
                  </ul>
                </div>
              </div>
            </div>
            <div className="m-logout">
              <Link className="m-logout" to="#" onClick={(e) => handleClickLogout(e)} title="로그아웃">
                <span className="hid">로그아웃</span>
              </Link>
            </div>
            <Link className="fullmenu fullmenuBtn" id="fullmenuOpen" to="#fullMenu" title="전체 메뉴">
              <em><em><span className="hid">전체메뉴</span></em></em>
            </Link>
          </div>
        </div>

        <div className="hdt-link">
          <div className="ht-tit">
            <Link to="/" title="홈 화면으로 이동">
              <h1 className="logo">
                <span className="hid">e.CLOUD</span>
              </h1>
            </Link>
            {/* 25.05.13 권한별 뱃지 추가 */}
            {userInfo && (
              <div className="account-badge">
                <span>{getUserRoleByUserInfo(userInfo)}</span>
              </div>
            )}
          </div>
          <div className="hd-menu">
            <MegaMenu visible={true} menus={menus} activeMenu={activeMenu} onClick={handleClickMenu} />
          </div>
          <div className="util">
            <Account />
          </div>
        </div>
      </header>
      <div className="popFullmenu">
        <div id="fullMenu">
          <h3 className="hid">전체메뉴</h3>
          <div className="nav">
            <MenuItem lev={1} menus={menus} />
          </div>
        </div>
      </div>
    </>
  );
}
